// $i18n.locale === 'zh-cn' ?
// $t('data.dataManagement')
export default {
  main: {
    change_identity: 'Switch Identities'
  },
  status: {
    normal: 'Normal',
    abnormal: 'Abnormal',
    awaiting_assessment: 'Awaiting Assessment',
    evaluated: 'Evaluated',
    unknown: 'Unknown',
    low_risk: 'Low Risk',
    medium_risk: 'Medium Risk',
    high_risk: 'High Risk',
    approved: 'Approved',
    approval_failed: 'Approval Failed',
    fetal_type: 'Fetal type',
    have: 'have',
    none: 'none',
    qcRemark: 'Please enter quality control notes',
    qcTitle: 'Report Review',
    qcBtn: 'Submit'
  },
  normal: {
    no: 'No.',
    add: 'Add',
    incomplete: 'The entered information is incomplete, please fill in the required information',
    submit: 'Submit',
    submitting: 'Submitting...',
    loading: 'Loading...',
    upload_pic: 'Please upload the picture',
    not_empty: 'not be empty',
    upload: 'upload',
    upload_succeeded: 'Upload Succeeded, please add information in time',
    upload_failed: 'Upload Failed',
    sure_give_up: 'Are you sure you want to discard editing?',
    edit: 'Edit',
    operation_succeeded: 'Success',
    base_info: 'Base Info'
  },
  rule: {
    not_empty: 'Not be empty',
    only_char_num_chinese: 'Only numbers, letters and Chinese can be entered'
  },
  search: {
    search: 'Retrieval',
    search2: 'Search',
    reset: 'Reset',
    show: 'Preview',
    pregnant_women_search: 'Pregnant women search',
    pregnancy_women_search: 'Information retrieval of pregnant women',
    hospital: 'Hospital',
    hospital_placeholder: 'Please select a hospital',
    full_name: 'Name',
    enter_name: 'Please enter the name',
    id_card: 'ID Card',
    enter_id_card: 'Please enter the ID card',
    clinic_number: 'Medical record No.',
    enter_clinic_number: 'Please enter the Medical record No.',
    phone_number: 'Tel',
    enter_phone: 'Please enter the tel',
    pregnancy: 'pregnancy',
    pregnancy_placeholder: 'Please select pregnancy type',
    entry_time: 'Entry time',
    age: 'Age',
    pregnancy_num: 'Pregnancies',
    gestational_week: 'Gestational week',
    week: 'week',
    day: 'day',
    operation: 'Operation',
    select_delete: 'Please select the record to delete',
    make_sure: 'Are you sure to delete the selected record?',
    click_ok: 'When you click OK, these records will be completely deleted',
    delete_success: 'Delete succeeded',
    assessment: 'Evaluation',
    details: 'Details',
    calculation: 'Calculation',
    delete: 'Delete',
    import: 'Import',
    export: 'Export',
    export_all: 'Export ALL',
    export_lucina: 'Export to Lucina',
    queryCriteria: 'Query Criteria',
    define: 'Define',
    cancel: 'Cancel',
    examine: 'Audit',
    print: 'Print',
    print_preview: 'Print Preview',
    update_time: 'Update time',
    calibration: 'Calibration',
    createTime: 'createTime',
    import_data: 'Import Data',
    import_succeeded: 'Import Succeeded',
    import_failure_records: 'Import Failure Records',
    error_line: 'Error Line',
    error_message: 'Error Message',
    export_succeeded: 'Export Succeeded'
  },
  login: {
    login: 'Log in',
    account: 'Account',
    enter_account: 'Please Enter Your Account',
    password: 'Password',
    enter_password: 'Please Enter Password',
    forgot_password: 'Forgot?',
    remember_password: 'Remember me',
    anonymous_login: 'Anonymous',
    contact_us: 'Please contact the administrator to obtain a new password',
    contact_tel: 'Administrator contact information',
    failed_exit: 'Failed to log out',
    modify_avatar: 'Modify Avatar'
  },
  home: {
    personal_center: 'Personal Center',
    password_modification: 'Password modification',
    old_password: 'old password',
    new_password: 'new password',
    confirm_password: 'confirm password',
    new_password_rule: 'At least 8-bit password, case sensitive',
    new_password_rule1: 'Please enter at least 8 characters, including three or more of upper case letters, lower case letters, numbers and special characters.',
    log_out: 'Log out',
    today_num: 'Quantity in that day',
    week_num: 'Quantity in this week',
    month_num: 'Quantity in this month',
    assessment_completed: 'Assessment completed',
    report_printed: 'Report printed',
    incomplete_assessment: 'Incomplete assessment',
    report_not_printed: 'Report not printed',
    positive_rate: 'Statistics of positive detection rate',
    gestational_week_distribution: 'Distribution proportion of delivery gestational weeks',
    pregnant_women_age_distribution: 'Proportion of age distribution of pregnant women',
    eclampsia_risk_rate: 'Statistics of risk factors of PE',
    downs_risk_rate: 'Statistics of risk factors of DS',
    sga_risk_rate: 'Statistics of various risk factors of SGA',
    fgr_Risk_rate: 'Statistics of risk factors of FGR',
    dvt_risk_rate: 'Statistics of risk factors of DVT',
    plgf_point: 'PLGF Median Change Trend',
    utpi_point: 'UTPI Median Change Trend',
    sflt_point: 'sFlt-1 Median Change Trend',
    papp_point: 'PAPP-A Median Change Trend',
    median_change_trend: 'Median Change Trend',
    distribution_point: 'Distribution Point',
    patient: 'Patient'
  },
  databoard: {
    maintitle: 'Intelligent Maternal And Child Data Platform',
    title1: 'Ranking list of the number of pregnant women entered',
    title2: 'Proportion of age and disease distribution of pregnant women',
    title3: 'Proportion of age distribution of pregnant women',
    title4: 'Proportion of major diseases of pregnant women',
    title5: 'Statistics of pregnant women\'s outcomes',
    title6: 'Predicted positive rate',
    hospital_info: 'Current hospital information',
    hospital_address: 'Hospital address',
    hospital_level: 'Hospital grade',
    hospital_phone: 'Hospital telephone',
    estimate_num: 'Number of completed assessments',
    gravida_num: 'Number of pregnant women entered',
    delivery_num: 'Number of deliveries completed',
    people: 'people',
    title7: 'Distribution of pregnant women in the risk assessment project',
    title8: 'Statistics of pregnant women\'s outcomes',
    hospital_num: 'Hospital Num',
    gravida_num2: 'Gravida Num',
    maternity_num: 'Maternity Num'
  },
  infoEntry: {
    personal_information: 'Personal Information',
    past_medical_history: 'Past Medical History',
    obstetric_history: 'Obstetrical History',
    full_name: 'Name',
    enter_name: 'Please enter the name',
    phone_number: 'Tel',
    enter_phone: 'Please enter the tel',
    clinic_number: 'Medical record No.',
    enter_clinic_number: 'Please enter the Medical record No.',
    gender: 'Gender',
    id_card: 'ID card',
    enter_id_card: 'Please enter the ID card',
    check_id_card: 'ID card Error',
    date_of_birth: 'Birthday',
    choose_birth_day: 'Please select the birthday',
    age: 'Age',
    age_placeholder: 'Please enter the age',
    years: 'years',
    height: 'Height',
    enter_height: 'Please enter the height',
    weight_before_pregnancy: 'Weight before pregnancy',
    enter_weight: 'Please enter the weight before pregnancy',
    pre_pregnancy_BMI: 'BMI before pregnancy',
    pre_pregnancy_BMI_placeholder: 'Please enter the BMI before pregnancy',
    race: 'Race',
    nation: 'Nation',
    menstrual_cycle: 'Menstrual Cycle',
    enter_menstrual_cycle: 'Please enter menstrual cycle',
    week: 'week',
    day: 'day',
    last_menstruation: 'LMP',
    choose_last_menstruation: 'Please select the LMP',
    mode_of_pregnancy: 'Pregnancy mode',
    choose_mode_of_pregnancy: 'Please select the pregnancy mode',
    number_of_getuses: 'Number of fetuses',
    choose_number_of_getuses: 'Please select the number of fetuses',
    consanguineous_marriage: 'Consanguineous marriage',
    consanguineous_marriage_placeholder: 'Please select the consanguineous marriage',
    group: 'Group',
    smoking_history: 'Smoking history',
    smoking_history_placeholder: 'Please select the smoking history',
    drinking_history: 'Drinking history',
    drinking_history_placeholder: 'Please select the drinking history',
    incomplete: 'The entered information is incomplete, please fill in the required information',
    already_exists: 'Record already exists',
    overwrite: 'The record already exists. Do you want to overwrite the original record',
    no: 'No',
    yes: 'Yes',
    preservation: 'Save',
    clear: 'Clear',
    previous_page: 'Previous',
    next_page: 'Next',
    chronic_hypertension: 'History of chronic hypertension',
    chronic_hypertension_placeholder: 'Please select history of chronic hypertension',
    diabetes: 'Type of diabetes',
    diabetes_placeholder: 'Please select the type of diabetes',
    treatment: '(diabetes) Treatment methods ',
    treatment_placeholder: 'Please select the treatment method',
    sle: 'SLE',
    sle_placeholder: 'Please select SLE',
    aps: 'APS',
    aps_placeholder: 'Please select APS',
    other_diseases: 'Other immune diseases',
    other_diseases_placeholder: 'Please input other immune diseases',
    eclampsia: 'Family history of PE',
    eclampsia_placeholder: 'Please select family history of PE',
    kidney_disease: 'CKD history',
    kidney_disease_placeholder: 'Please select the CKD history',
    liver_disease: 'History of liver disease',
    liver_disease_placeholder: 'Please select the history of liver disease',
    downs: "Family history of Down's family",
    downs_placeholder: "Please select the family history of Down's family",
    vte_famliy: 'Family history of VTE',
    vte_famliy_placeholder: 'Please select the family history of VTE',
    vte: 'History of VTE',
    vte_placeholder: 'Please select the history of VTE',
    varicose_veins: 'Varicosity of lower limbs',
    varicose_veins_placeholder: 'Please select the varicosity of lower limbs',
    medical_vomplications: 'Medical complications',
    medical_vomplications_placeholder: 'Please select the medical complications',
    thrombophilia: 'Thrombophilia',
    thrombophilia_placeholder: 'Please select the thrombophilia',
    vte_after_major: 'VTE history after major surgery',
    vte_after_major_placeholder: 'Please select the VTE history after major surgery',
    primipara: 'Primipara',
    primipara_title: '(Primipara: no experience of pregnancy more than 24 weeks)',
    primipara_placeholder: 'Please select whether you are a primipara',
    pregnancies_num: 'Number of pregnancies',
    pregnancies_num_placeholder: 'Please enter the number of pregnancies',
    deliveries_num: 'Number of deliveries',
    deliveries_num_placeholder: 'Please select the number of deliveries',
    last_delivery_Time: 'Time of previous delivery',
    last_delivery_Time_placeholder: 'Please select the last delivery time',
    gestational_weeks_of_previous_delivery: 'Gestational weeks of previous delivery',
    previous_newborn_weight: 'Low birth weight',
    previous_newborn_weight_placeholder: 'Please enter the weight of the newborn',
    before_delivery_Time: 'Time of history delivery',
    before_delivery_Time_placeholder: 'Please select history delivery time',
    gestational_weeks_of_before_delivery: 'Gestational weeks of history delivery',
    history_of_adverse_pregnancy: 'Adverse pregnancy history',
    name_not_empty: 'Name cannot be empty',
    phone_not_empty: 'Mobile phone number cannot be empty',
    phone_11: 'The length of the mobile phone number is 11 digits.',
    idCard_not_empty: 'ID card or Medical record No. cannot be empty',
    age_not_empty: 'Age cannot be empty',
    birth_not_empty: 'Date of birth cannot be empty',
    height_not_empty: 'Height: cannot be empty',
    height_no_less_than_80: 'Height: no less than 80cm',
    height_no_more_than_250: 'Height: no more than 250cm',
    weight_not_empty: 'Weight: cannot be empty',
    weight_no_less_than_25: 'Weight: no less than 25kg',
    weight_no_more_than_250: 'Weight: no more than 250kg',
    race_not_empty: 'Race cannot be empty',
    nation_not_empty: 'Nationality cannot be empty',
    menstrualCycle_not_empty: 'Menstrual cycle cannot be empty',
    menstrualCycle__no_less_than_10: 'Menstrual cycle: no less than 10',
    lastMenstruation_not_empty: 'Last menstruation cannot be empty',
    pregnancyMode_not_empty: 'Pregnancy method cannot be blank',
    babyNum_not_empty: 'Number of fetuses cannot be empty',
    isCloseMarriage_not_empty: 'Recent marriage cannot be empty',
    isSmoke_not_empty: 'Smoking history cannot be empty',
    isDrink_not_empty: 'Drinking history cannot be empty',
    save_success: 'Saved successfully',
    normal_range: 'Normal range',
    sp_no_less_than_30: 'Systolic pressure: no less than 90mmHg',
    sp_no_more_than_240: 'Systolic pressure: no more than 140mmHg',
    dp_no_less_than_20: 'Diastolic pressure: no less than 60mmHg',
    dp_no_more_than_180: 'Diastolic pressure: no more than 90mmHg'
  },
  pregnancy: {
    basic_information_of_pregnancy_test: 'Basic information of PG test',
    edit_basic_information_of_pregnancy_test: 'Edit Basic information of PG test',
    ultrasonic_information: 'Ultrasound Information',
    edit_ultrasonic_information: 'Edit ultrasonic information',
    biochemical_markers: 'Biomarkers',
    edit_biochemical_markers: 'Edit new disease information',
    new_disease: 'New Symptoms',
    edit_new_disease: 'Edit New Symptoms',
    medication_history: 'Medication history',
    edit_medication_history: 'Edit Medication History',
    pregnancy_test_information: 'PG Test Information',
    gestational_week: 'Gestational Week',
    essential_information: 'Basic Information',
    name_of_pregnant_woman: 'Name',
    please_enter_the_name_of_the_pregnant_woman: 'Please enter the name of the pregnant woman',
    evaluation_items: 'Evaluation items',
    clinic_no: 'Medical record No.',
    clinic_no_placeholder: 'Please enter the Medical record No.',
    gestational_age_calculation: 'Calculation method of gestational weeks',
    gestational_age_calculation_placeholder: 'Please select the calculation method of gestational weeks',
    left_arm_first_time: 'Left Arm First',
    sp_dp: '(SBP/DBP)',
    systolic_pressure: 'SBP',
    diastolic_pressure: 'DBP',
    pregnancy: 'Gestational period',
    pregnancy_placeholder: 'Please select gestational period',
    inspection_date: 'Date',
    inspection_date_placeholder: 'Please select the date',
    right_arm_first_time: 'Right Arm First',
    sending_hospital: 'Hospital',
    sending_hospital_placeholder: 'Please enter the hospital',
    left_arm_second_time: 'Left Arm Second',
    weight: 'Weight',
    weight_placeholder: 'Please enter the weight',
    sending_doctor: 'Doctor',
    sending_doctor_placeholder: 'Please enter the doctor',
    right_arm_second_time: 'Right Arm Second',
    height: 'Height',
    inspection_department: 'Department',
    inspection_department_placeholder: 'Please select the Department',
    mean_arterial_pressure: 'mean arterial pressure',
    date_of_submission_for_inspection: 'Date of submission for inspection',
    date_of_submission_for_inspection_placeholder: 'Please select the inspection date',
    message_1: 'Please search and select the pregnancy number of the pregnant woman',
    pregnancy_type: 'Pregnancy Type',

    left: 'Left',
    right: 'Right',
    average: 'Average ',
    utpi_no_less_than: 'UTPI: Not less than 0',
    utpi_no_more_than: 'UTPI: Not more than 10',
    crl: 'CRL',
    crl_no_empty: 'CRL:Not Empty',
    crl_no_less_than: 'CRL: Not less than 25',
    crl_no_more_than: 'CRL: Not more than 110',
    crown_rump_length_placeholder: 'Gestational Week of CRL',
    head_circumference: 'HC',
    bpd: 'BPD',
    bpd_no_empty: 'BPD:Not Empty',
    bpd_no_less_than: 'BPD: Not less than 10',
    bpd_no_more_than: 'BPD: Not more than 120',
    abdominal_circumference: 'AC',
    nuchal_translucency: 'NT',
    nt_mom: 'MoM value of NT',
    nt_weel: 'Gestational Week of NT',
    value: 'value',
    femur_length: 'Femur Length',
    test_date: 'Test Date',
    test_date_placeholder: 'Please select testing date',
    test_no: 'Test No',
    test_no_placeholder: 'Please enter the test number',
    fetal_weight: 'Fetal Weight',
    message_2: "Please submit the pregnant women's pregnancy test information first",

    marker_type: 'Type ',
    marker_type_placeholder: 'Please select type',
    instrument_type: 'Instrument Type',
    instrument_type_placeholder: 'Please select instrument type',
    sample_no: 'Sample Code',
    sample_no_placeholder: 'Please enter the sample code',
    sample_type: 'Sample Type',
    sample_type_placeholder: 'Please select sample type',
    sample_characteristics: 'Sample Attribution ',
    sample_characteristics_placeholder: 'Please select sample attribution',
    sampling_date: 'Date Collected',
    sampling_date_placeholder: 'Please select date collected',
    concentration_value: 'Detection Value',
    concentration_value_placeholder: 'Please enter the value',
    operation_time: 'Operation Time',

    name_of_new_disease: 'Name of New Symptom',
    click_select: 'Click Select',
    dagnostic_gestational_age: 'Diagnose of Gestational Age',
    date_of_diagnosis: 'Date of Diagnose',
    date_of_diagnosis_placeholder: 'Click Select Date',
    hospitalization: 'Hospital Treatment',
    hospitalization_placeholder: 'Please select whether to be hospitalized',
    disease_reversion: 'Disease Reversion',
    disease_reversion_placeholder: 'Please enter the disease return',
    remark: 'Remarks',
    remark_placeholder: 'Please enter remarks',

    drug_name: 'Drug Name',
    drug_name_placeholder: "Please enter drug's name",
    specification: 'Specification',
    specification_placeholder: 'Please enter specification',
    total_daily_dose: 'Total Daily Dose',
    total_daily_dose_placeholder: 'Please enter total daily dose',
    take_way: 'Take Way',
    take_way_placeholder: 'Please enter take way',
    take_day: 'Take Day',
    take_day_placeholder: 'Please enter take day',
    take_gestational_weeks: 'Take Gestational Weeks',
    take_gestational_weeks_placeholder: 'Please enter take gestational weeks',
    medication_ADHERENCE: 'Medication ADHERENCE',
    medication_ADHERENCE_placeholder: 'Please enter medication ADHERENCE'
  },
  outcome: {
    pregnancy_outcome: 'Pregnancy Outcomes',
    delivery_information: 'Delivery Information',
    terminal_pregnancy: 'Termination of Pregnancy',
    terminal_pregnancy_placeholder: 'Please select whether to terminate the pregnancy',
    termination_of_pregnancy: 'Gestational weeks for termination of pregnancy',
    termination_reason: 'Reasons for termination of pregnancy',
    termination_reason_placeholder: 'Please enter the reason for termination of pregnancy',
    delivery_mode: 'Mode of Delivery',
    delivery_mode_placeholder: 'Please select the mode of delivery',
    gestational_week_of_delivery: 'Gestational weeks of delivery',
    drug_use_during_pregnancy: 'Medication During Pregnancy',
    drug_use_during_pregnancy_placeholder: 'Please select the medication during pregnancy',
    therapeutic_drugs: 'Therapeutic Drug',
    therapeutic_drugs_placeholder: 'Please enter the therapeutic drug',
    compliance_evaluation: 'Compliance Evaluation',
    compliance_evaluation_placeholder: 'Please select compliance evaluation',
    newborn_weight: 'Neonatal Weight',
    newborn_weight_placeholder: 'Please enter the neonatal weight',
    newborn_height: 'Neonatal Height',
    newborn_height_placeholder: 'Please enter the neonatal height',
    pregnancy_woman_outcome: 'Outcomes of Pregnant Woman',
    edit_pregnancy_woman_outcome: 'Maternity Outcome Editor',
    disease_name: 'Diseases (Pregnancy)',
    disease_name_placeholder: 'Please select disease name',
    diagnosis_time: 'Date of Diagnosis',
    diagnosis_time_placeholder: 'Please select the date of diagnosis',
    remark: 'Remarks',
    neonatal_outcome: 'Neonatal Outcome',
    edit_neonatal_outcome: 'Neonatal Outcome Editing'
  },
  follow: {
    postpartum_follow_up: 'Postpartum Follow-up',
    edit_postpartum_follow_up: 'Postpartum Follow-up Editor',
    temperature: 'temperature',
    temperature_placeholder: 'Please enter temperature',
    temperature_not_empty: 'Temperature: cannot be empty',
    temperature_no_less_than_0: 'Temperature: no less than 0℃',
    temperature_no_more_than_60: 'Temperature: no more than 60℃'
  },
  risk: {
    risk_factors: 'Past Medical History & Obstetric History risk factors',
    new_onset_risk_factors: 'New Onset Risk Factors',
    risk_assessment_result: 'Risk Assessment Results',
    guidance: 'Suggestion',
    preeclampsia: 'PE',
    downs: 'DS',
    sga: 'SGA',
    fgr: 'FGR',
    benous_thrombosis: 'DVT',
    plgf_value: 'Reference Value of PLGF',
    plgf_result: 'Evaluation Result of PLGF',
    sft_value: 'Reference Value of PLGF/sFlt-1',
    sflt_result: 'Evaluation Result of PLGF/sFlt-1',
    early_onset_PE: 'Early Onset PE',
    premature_PE: 'Premature PE',
    basic_risk_assessment: 'Basic Risk Assessment',
    final_risk_assessment: 'Final Risk Assessment',
    basic_risk_assessment_value: 'Basic Risk Assessment Value',
    final_risk_assessment_value: 'Final Risk Assessment Value',
    evaluation_result: 'Evaluation Result',
    prenatal_factors: 'Prenatal Factors',
    postnatal_factors: 'Postnatal Factors',
    temporary_factor: 'Temporary Factor',
    evaluation_score: 'Evaluation Score',
    estimate_error: 'Evaluate Error',
    no_evaluation_information: 'No Evaluation Information'
  },
  data: {
    dataManagement: 'Data Management',
    evaluation_items: 'Evaluation Items',
    evaluation_items_placeholder: 'Please select an evaluation item',
    pregnancy_test_date: 'Pregnancy Test Date',
    risk_assessment: 'Risk Assessment',
    risk_assessment_placeholder: 'Evaluate',
    evaluation_status: 'Evaluation Status',
    evaluation_status_placeholder: 'Please select the evaluation status',
    evaluation_results: 'Evaluation Results',
    evaluation_results_placeholder: 'Please select the evaluation result',
    data_status: 'Data Status',
    data_status_placeholder: 'Please select data status',
    group_type_placeholder: 'Please select group type',
    evaluation_date: 'Assessment Date'
  },
  qc: {
    qcReview: 'Quality Control Review',
    qcObject: 'Quality Control Object',
    qcQuery: 'Quality Control Query',
    detection_time: 'Sampling time',
    gestational_age_range: 'Gestational Range',
    ethnic_type: 'Nation',
    ethnic_type_placeholder: 'Please select the nation',
    race_type: 'Race',
    race_type_placeholder: 'Please select the race',
    qcResults: 'Quality Control Results',
    qcResults_placeholder: 'Please select QC result',
    xbMap: 'X-B quality Control Chart',
    advanced_options: 'Advanced options',
    generate_results: 'Generate quality control results',
    define: 'Confirmation',
    pass: 'Pass',
    fail: 'Fail',
    audit_date: 'Audit date',
    mom_value: 'Composite mean MoM Value',
    examination_result: 'Examination Tesult & Recommendation',
    condition: 'Condition',
    good: 'Report Example (Good)',
    bad: 'Report Example (Bad)',
    ewma_chart: 'EWMA Quality Control Chart',
    marker_type: 'Marker Type',
    mom_value2: 'Average MoM Value',
    audit_result: 'Audit Result'
  },
  report: {
    report_management: 'Report Management',
    evaluation_date: 'Evaluation Date',
    evaluation_type: 'Evaluation Type',
    evaluation_type_placeholder: 'Please select an evaluation type',
    evaluation_status: 'Evaluation status',
    evaluation_status_placeholder: 'Please select the evaluation status',
    evaluation_results: 'Evaluation results',
    evaluation_results_placeholder: 'Please select the evaluation result',
    print_status: 'Printer Status',
    print_status_placeholder: 'Please select the print status',
    audit_status: 'Examine Status',
    audit_status_placeholder: 'Please select the examine status',
    test_items: 'Test Items',
    english_abbreviation: 'English Abbreviation',
    sampling_gestational_week: 'Sampling Gestational Week',
    result: 'Result',
    unit: 'Unit',
    mom_value: 'MoM Value',
    early_onset: 'Early onset',
    premature: 'Premature',
    full_term: 'Full Term',
    report_printing: 'Report printing'
  },
  sys: {
    parameter_management: 'General parameter management',
    home_setting: 'Home page display settings',
    risk_setting: 'Risk assessment project settings',
    pregnancy_setting: 'System pregnancy settings',
    ultrasound_setting: 'Setting of B-ultrasound pregnancy week calculation',
    qc_setting: 'QC Calculation Settings',
    positive_rate: 'Positive Detection Rate',
    downs: 'Down Syndrome',
    delivery_week_dis: 'Distribution of delivery weeks',
    trend: 'Median Curve',
    utpi_trend: 'UTPI Trends',
    vte: 'VTE',
    sga: 'SGA',
    pregnant_age_dis: 'Age Distribution',
    sflt_trend: 'SFlt-1 Trend',
    preeclampsia: 'Preeclampsia',
    fgr: 'FGR',
    plgf_trend: 'PLGF Trends',
    pappa_trend: 'PAPP-A Trends',
    tang_screen: 'Tang Screen',
    fgr2: 'Growth Restriction',
    first_trimester: 'First Trimester',
    second_trimester: 'Second Trimester',
    third_trimester: 'Third Trimester',
    trimester_start: 'Start',
    trimester_end: 'End',
    pregnancy_time: 'Total length of pregnancy',
    crl: 'Upper and lower limits of CRL measured value',
    bpd: 'Upper and lower limit of BPD measured value',
    value_up_placeholder: 'Please enter the upper limit of the measured value',
    value_down_placeholder: 'Please enter the lower limit of the measured value',

    aerfa: 'Calculation Parameters α',
    beita: 'Calculation Parameters β',
    aerfa_placeholder: 'Please enter calculation parameters α',
    beita_placeholder: 'Please enter calculation parameters β',
    xb_upper: 'X-B Upper',
    xb_upper_placeholder: 'Please enter X-B Upper',
    ewma_upper: 'EWMA Upper',
    ewma_upper_placeholder: 'Please enter EWMA Upper',

    hospital_management: 'Hospital management',
    hospital_alg_management: 'Hospital Algorithm management',
    alg_edit: 'Edit Algorithm',
    now_hospital: 'Current hospital',
    search_placeholder: 'Please select the hospital to query',
    hospital_name: 'Hospital Name',
    address: 'Address',
    hospital_grade: 'Hospital Grade',
    superior_hospital: 'Superior Hospital',
    contacts: 'Contacts',
    contact_number: 'Contact Tel.',

    add_hospital: 'New Hospital',
    edit_hospital: 'Edit Hospital',
    country: 'Country',
    country_placeholder: 'Please select your country',
    province: 'Province (State)',
    province_placeholder: 'Please select your province',
    city: 'City',
    city_placeholder: 'Please select your city',
    area: 'District',
    area_placeholder: 'Please select the district',
    name: 'Hospital/institution',
    name_placeholder: 'Please enter the name of the hospital or institution',
    level: 'Hospital/institution level',
    level_placeholder: 'Please select the hospital or institution level',
    up_hospital: 'Superior hospital/institution',
    up_hospital_placeholder: 'Please select the superior hospital or institution',
    address2: 'Hospitals/institutions address',
    address2_placeholder: 'Please enter the address of the Hospital/Institution',
    contacts_placeholder: 'Please enter the contact person of Hospital/Institution',
    region: 'Region',
    region_placeholder: 'Please select the region',
    contact_number_placeholder: 'Please enter the contact phone number',
    logo: 'LOGO',
    logo_placeholder: 'Size: 800px * 800px | Size: unlimited, size can be determined according to the actual situation | Format: jpg, gif, png, jpeg',
    electronic_seal: 'Upload Electronic Seal',
    electronic_seal1: 'E-stamp 1',
    electronic_seal2: 'E-stamp 2',
    electronic_seal3: 'E-stamp 3',
    longitude: 'Longitude',
    latitude: 'Latitude',

    template_management: 'Template Management'
  },
  user: {
    user_management: 'User Management',
    user_placeholder: 'Please enter user name',
    username: 'User Name',
    username_placeholder: 'Please enter user name',
    permission: 'User Permission',
    permission_placeholder: 'Please select the user permission',
    hospital: 'Hospital/institution',
    avatar: 'Avatar',
    avatar_placeholder: 'Upload Avatar',
    password: 'Password',
    password_placeholder: 'Please set the login password',
    phone: 'Tel.',
    phone_placeholder: "Please enter the user's mobile number",
    electronic_signature: 'E-signature',
    electronic_signature_placeholder: 'Signature photo here',
    hospital_placeholder: 'Please select the Hospital/Institution',
    add_user: 'Add User',
    edit_user: 'Edit User',
    confirm_modification: 'Confirm',
    reset_password: 'Reset Password'
  },
  temp: {
    edit_temp: 'Template Editing'
  },
  algorithm: {
    algorithm_detail: 'Algorithm Details',
    preeclampsia: 'Preeclampsia',
    tang_screen: 'Tang Screen',
    sga: 'Sga',
    fgr: 'Fgr',
    last_modified_date: 'Last Modified Date',
    algorithm_evaluation_range: 'Algorithm evaluation Allowable gestational age range',
    first_trimester_range: 'First Trimester Range',
    second_trimester_range: 'Second Trimester Range',
    third_trimester_range: 'Third Trimester Range',
    trimester_range_placeholder: 'Start',
    trimester_range_placeholder2: 'End',
    screening_method: 'Screening Method',
    first_trimester: 'First Trimester',
    first_trimester_placeholder: 'Single Pregnancy Period',
    second_trimester: 'Second Trimester',
    second_trimester_placeholder: 'Please select the screening method for the second trimester',
    third_trimester: 'Third Trimester',
    third_trimester_placeholder: 'Please select the screening method for the third trimester',

    model_cutoff_value_setting: 'Algorithm model Cutoff parameter',
    model_critical_cutoff_value_setting: 'Algorithm model critical Cutoff parameter',
    critical: 'Critical',
    first_trimester_early: 'First trimester-Early onset Cutoff',
    second_trimester_early: 'Second trimester-Early onset Cutoff',
    third_trimester_early: 'Third trimester-Early onset Cutoff',
    first_trimester_preterm: 'First trimester-Premature delivery Cutoff',
    second_trimester_preterm: 'Second trimester-Premature delivery Cutoff',
    third_trimester_preterm: 'Third trimester-Premature delivery Cutoff',
    first_trimester_term: 'First trimester-Term Cutoff',
    second_trimester_term: 'Second trimester-Term Cutoff',
    third_trimester_term: 'Third trimester-Term Cutoff',
    gestational_week_range: 'Allowed gestational week range of algorithm evaluation',

    detection_value_setting: 'Detection quantity Cutoff, value setting',
    placeholder1: '12-15 weeks>32pg/mL',
    placeholder2: '16-20 weeks>60pg/mL',
    placeholder3: ' over 20 weeks>100pg/mL',
    placeholder4: '20-33 weeks +6<38',
    placeholder5: 'Over 33 weeks <38',

    algorithm_evaluation_model: 'Evaluation Model',
    model_placeholder1: 'Please select the first trimester evaluation model',
    model_placeholder2: 'Please select the second trimester evaluation model',
    model_placeholder3: 'Please select the third trimester evaluation model',

    plgf_coefficient: 'Coefficient of PLGF',
    week_coefficient: '-week coefficient',

    risk_judgment_criteria: 'Risk Judgment Criterion',
    risk_judgment_criteria_placeholder: 'Please select the risk judgment criterion',

    median_calibration: 'Median calibration of markers',
    marker_type: 'Marker Type',
    marker_type_placeholder: 'Please select the marker type',
    pregnancy_type: 'Type of pregnancy',
    pregnancy_type_placeholder: 'Please select the pregnancy type',
    ga_calib_model: 'GA Calibration Model',
    weight_calib_model: 'Weight calibration model',
    choose_model: 'Please select calibration model',

    journal: 'Journal'
  },
  log: {
    journal: 'Journal',
    operation_type: 'Operation Type',
    operation_type_placeholder: 'Please select the operation type',
    operation_content: 'Operation Content',
    operation_content_placeholder: 'Please select the operation content',
    operation_user: 'Operator',
    operation_user_placeholder: 'Please enter the operator name to search',
    operation_time: 'Operation Time'
  },
  hospitalLevel: {
    hospital_level_management: 'Hospital/institution level management',
    hospital_level_management_placeholder: 'Please enter the hospital/institution level',
    hospital_level_add: 'New hospital/institution level',
    title: 'Title',
    title_placeholder: 'Please enter a title',
    priority: 'Priority',
    priority_placeholder: 'Please enter the priority',
    hospital_level_edit: 'Modify hospital/institution level information'
  },
  help: {
    help: 'Help',
    common_problem: 'Common Problem',
    full_pregnancy_management_plan: 'Full Pregnancy Management Plan',
    common_chart: 'General Operation Process',
    person_chart: 'Individual Operation Flow Chart',
    batch_chart: 'Batch Operation Flow Chart',
    technical_support: 'Technical Support',
    ver_record: 'Version Maintenance Record',
    downs: 'Downs',
    vte: 'DVT',
    sga: 'SGA',
    preeclampsia: 'Preeclampsia',
    fgr: 'FGR',
    data_entry: 'Data Entry',
    fast_data_positioning: 'Fast Data Positioning',
    risk_assessment: 'Risk Assessment',
    report_management: 'Report Management'
  },
  about: {
    about: 'About',
    team_profile: 'Team Profile',
    project_intro: 'Project Introduction',
    preeclampsia: 'Preeclampsia',
    tang_screen: 'Tang Screen',
    sga: 'SGA',
    fgr: 'FGR',
    vte: 'VTE',
    system_info: 'System Information',
    precautions: 'Precautions During Pregnancy'
  },
  ovarianReserve: {
    enter: 'please enter the ',
    AMH: 'AMH',
    bFSH: 'bFSH',
    AFC: 'AFC',
    MenarcheAge: 'Menarche Age',
    count: 'Count'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en-us.js